/* Richiesta con allegati: "Preventivo Procurement Aziendale" e "Cerca per obiettivo".
   Il markup e il perche' stanno in snippets/ames-richiesta.liquid.

   Il giro di un invio:
     1. si controlla il modulo (testo, nome, email, consenso);
     2. ogni file, uno alla volta: foto e video si comprimono nel browser,
        poi si caricano come proprieta' di una riga del prodotto tecnico
        "allegati-richieste" (/cart/add.js accetta file, il modulo contatti
        no). Shopify risponde con l'indirizzo del file sul suo CDN, e la riga
        si toglie subito dal carrello;
     3. gli indirizzi entrano nel campo "Allegati" e il modulo contatti parte
        normalmente: la mail arriva al negozio come quelle dei preventivi.
   Limite misurato sul negozio: 20 MB per richiesta, quindi 19 MB a file.

   Dal 20/10/2026 "Cerca per obiettivo" non manda la mail: apre WhatsApp
   (numero in data-rq-wa) con il testo gia' scritto, e foto e video il
   cliente li allega nella chat, senza limiti. Questo giro resta per il
   Preventivo Procurement. */
(function () {
  'use strict';
  var box = document.querySelector('[data-rq]');
  if (!box) return;

  var T = window.AMES_RQ_T || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var form = box.querySelector('form');
  var vid = box.getAttribute('data-rq-variant');
  var lista = box.querySelector('[data-rq-lista]');
  var inFile = box.querySelector('[data-rq-file]');
  var drop = box.querySelector('[data-rq-drop]');
  var msg = box.querySelector('[data-rq-msg]');
  var invia = box.querySelector('[data-rq-invia]');
  var testo = box.querySelector('#ames-rq-testo');
  var grazie = box.querySelector('[data-rq-grazie]');

  var MAX = 19 * 1024 * 1024;
  var MAX_FILE = 8;
  var CHIAVE = 'ames_rq_inviata';
  var DOC = /\.(pdf|csv|xls|xlsx|xlsm|ods)$/i;
  var MODI = {
    procurement: { accept: '.pdf,.csv,.xls,.xlsx,.xlsm,.ods,application/pdf,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet' },
    obiettivo: { accept: 'image/*,video/*' }
  };

  var modo = 'procurement';
  var voci = [];          /* {file, nome, stato, url, el, err} */
  var apertoDa = null;
  var occupato = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function peso(n) {
    return n > 1048576 ? (n / 1048576).toFixed(1).replace('.', ',') + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB';
  }
  function base(nome) { return String(nome || 'file').replace(/\.[^.]+$/, ''); }

  /* ── Apertura e chiusura ─────────────────────────────────────────────── */

  function imposta(m) {
    modo = MODI[m] ? m : 'procurement';
    box.setAttribute('data-rq-modo', modo);
    box.querySelectorAll('[data-rq-solo]').forEach(function (el) {
      var fuori = el.getAttribute('data-rq-solo') !== modo;
      el.hidden = fuori;
      /* i campi dell'altro modo non partono: niente righe vuote nella mail */
      el.querySelectorAll('input,select,textarea').forEach(function (c) { c.disabled = fuori; });
    });
    inFile.setAttribute('accept', MODI[modo].accept);
    testo.setAttribute('placeholder', testo.getAttribute('data-ph-' + modo) || '');
    box.querySelector('[data-rq-tipo]').value = modo === 'obiettivo' ? T.tipo_obiettivo : T.tipo_procurement;
    var az = box.querySelector('[data-rq-req-procurement]');
    if (az) az.required = modo === 'procurement';
    /* i file del modo sbagliato non passano da un modo all'altro */
    voci = voci.filter(function (v) { return accettato(v.file); });
    disegna();
  }

  function apri(m, da) {
    apertoDa = da || document.activeElement;
    imposta(m);
    grazie.hidden = true;
    form.hidden = false;
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    /* dalla ricerca senza risultati: la domanda scritta diventa la prima riga */
    var pre = da && da.getAttribute && da.getAttribute('data-rq-testo');
    /* il testo arrivato dalla ricerca o dal percorso guidato si aggiunge a quello
       gia' scritto, senza doppioni */
    if (pre) {
      var gia = testo.value.trim();
      if (!gia) testo.value = pre + String.fromCharCode(10);
      else if (gia.indexOf(pre) === -1) testo.value = gia + String.fromCharCode(10) + pre + String.fromCharCode(10);
    }
    if (copiato) copiato.hidden = true;
    if (riserva) riserva.hidden = true;
    if (typeof apriWa === 'function') apriWa();
    setTimeout(function () { testo.focus(); }, 30);
  }

  function chiudi() {
    if (occupato) return;
    box.hidden = true;
    document.documentElement.style.overflow = '';
    if (apertoDa && apertoDa.focus) apertoDa.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-apri-richiesta]');
    if (t) { e.preventDefault(); apri(t.getAttribute('data-apri-richiesta'), t); return; }
    if (box.hidden) return;
    if (e.target.closest('[data-rq-close]')) { e.preventDefault(); chiudi(); return; }
    /* "percorso guidato": lo apre ames-obiettivo.js, qui si fa solo posto */
    if (e.target.closest('[data-apri-obiettivo]') && box.contains(e.target)) chiudi();
  });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') { chiudi(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(box.querySelectorAll('button,input,textarea,select,a[href],label.ames-rq__scegli'),
        function (el) { return !el.disabled && el.offsetParent !== null && !el.classList.contains('visually-hidden'); });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ── File ─────────────────────────────────────────────────────────────── */

  function accettato(f) {
    if (modo === 'procurement') return DOC.test(f.name);
    return /^(image|video)\//.test(f.type) || /\.(heic|heif|jpe?g|png|webp|mov|mp4|m4v|webm|avi|3gp)$/i.test(f.name);
  }

  function aggiungi(files) {
    var avviso = '';
    Array.prototype.forEach.call(files || [], function (f) {
      if (voci.length >= MAX_FILE) { avviso = T.err_troppi; return; }
      if (!accettato(f)) { avviso = T.err_tipo + ' (' + f.name + ')'; return; }
      var comprimibile = modo === 'obiettivo';
      if (!comprimibile && f.size > MAX) { avviso = T.err_peso + ' (' + f.name + ')'; return; }
      voci.push({ file: f, nome: f.name, stato: 'attesa', url: '', err: '' });
    });
    msg.textContent = avviso;
    msg.classList.toggle('is-err', !!avviso);
    disegna();
  }

  function disegna() {
    lista.innerHTML = voci.map(function (v, i) {
      var st = v.stato === 'fatto' ? T.pronto : v.stato === 'comprimo' ? T.comprimo
        : v.stato === 'carico' ? T.carico : v.stato === 'errore' ? v.err : T.attesa;
      var pct = v.pct != null && (v.stato === 'comprimo' || v.stato === 'carico') ? ' ' + Math.round(v.pct * 100) + '%' : '';
      return '<li class="ames-rq__file is-' + v.stato + '"><span class="ames-rq__fnome">' + esc(v.nome) +
        '</span><span class="ames-rq__fpeso">' + peso((v.out || v.file).size) + '</span>' +
        '<span class="ames-rq__fstato">' + esc(st + pct) + '</span>' +
        (occupato ? '' : '<button type="button" class="ames-rq__frm" data-rq-rm="' + i + '" aria-label="' +
          esc(T.rimuovi + ' ' + v.nome) + '">×</button>') + '</li>';
    }).join('');
  }

  lista.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rq-rm]');
    if (!b || occupato) return;
    voci.splice(+b.getAttribute('data-rq-rm'), 1);
    disegna();
  });
  inFile.addEventListener('change', function () { aggiungi(inFile.files); inFile.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-sopra'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-sopra'); });
  });
  drop.addEventListener('drop', function (e) { if (e.dataTransfer) aggiungi(e.dataTransfer.files); });

  /* ── Compressione ─────────────────────────────────────────────────────── */

  /* Foto: lato lungo a 2000 px, JPEG 82%. Una foto da telefono passa da
     4-8 MB a 400-900 KB e resta leggibile per una targhetta o una misura.
     Se il browser non sa decodificarla (HEIC su Chrome) parte com'e'. */
  function comprimiFoto(f) {
    if (!window.createImageBitmap) return Promise.resolve(f);
    return createImageBitmap(f, { imageOrientation: 'from-image' }).then(function (bmp) {
      var s = Math.min(1, 2000 / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * s);
      c.height = Math.round(bmp.height * s);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      if (bmp.close) bmp.close();
      return new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', 0.82); });
    }).then(function (b) {
      return b && b.size < f.size ? new File([b], base(f.name) + '.jpg', { type: 'image/jpeg' }) : f;
    }).catch(function () { return f; });
  }

  /* Video: H.264 + AAC in MP4 con WebCodecs (libreria Mediabunny, caricata
     solo quando serve). Lato lungo 1280 px (854 oltre i 4 minuti) e bitrate
     calcolato sulla durata perche' il file stia sotto i 19 MB. Se il
     browser non ha WebCodecs il video parte com'e', purche' ci stia. */
  var mbPromessa = null;
  function comprimiVideo(v) {
    var f = v.file;
    if (!('VideoEncoder' in window) || !T.mb_url) return Promise.resolve(f);
    mbPromessa = mbPromessa || import(T.mb_url);
    return mbPromessa.then(function (MB) {
      var input = new MB.Input({ source: new MB.BlobSource(f), formats: MB.ALL_FORMATS });
      return Promise.all([input.getPrimaryVideoTrack(), input.computeDuration()]).then(function (r) {
        var vt = r[0], dur = Math.max(1, r[1] || 1);
        if (!vt) return f;
        var lato = Math.max(vt.displayWidth, vt.displayHeight) || 1280;
        var max = dur > 240 ? 854 : 1280;
        var s = Math.min(1, max / lato);
        var w = Math.max(2, Math.round(vt.displayWidth * s / 2) * 2);
        var budget = 17.5 * 1048576 * 8 / dur;
        var vb = Math.round(Math.max(250000, Math.min(2500000, budget - 96000)));
        return MB.canEncodeAudio('aac').then(function (aac) {
          var output = new MB.Output({ format: new MB.Mp4OutputFormat(), target: new MB.BufferTarget() });
          return MB.Conversion.init({
            input: input, output: output, showWarnings: false,
            video: { width: w, codec: 'avc', bitrate: vb, forceTranscode: true },
            audio: aac ? { codec: 'aac', bitrate: 96000 } : { codec: 'opus', bitrate: 96000 }
          }).then(function (conv) {
            if (!conv.isValid) return f;
            conv.onProgress = function (p) { v.pct = p; disegna(); };
            return conv.execute().then(function () {
              var b = new Blob([output.target.buffer], { type: 'video/mp4' });
              return b.size && b.size < f.size ? new File([b], base(f.name) + '.mp4', { type: 'video/mp4' }) : f;
            });
          });
        });
      });
    }).catch(function () { return f; });
  }

  function comprimi(v) {
    if (modo !== 'obiettivo') return Promise.resolve(v.file);
    if (/^image\//.test(v.file.type) && !/gif|svg/.test(v.file.type)) return comprimiFoto(v.file);
    if (/^video\//.test(v.file.type) || /\.(mov|mp4|m4v|webm|avi|3gp)$/i.test(v.file.name)) return comprimiVideo(v);
    return Promise.resolve(v.file);
  }

  /* ── Caricamento ──────────────────────────────────────────────────────── */

  function carica(v, file, n) {
    return new Promise(function (ok, ko) {
      var nome = 'Allegato ' + n;
      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', '1');
      fd.append('properties[' + nome + ']', file, file.name);
      var x = new XMLHttpRequest();
      x.open('POST', root + 'cart/add.js');
      x.setRequestHeader('Accept', 'application/json');
      x.upload.onprogress = function (e) { if (e.lengthComputable) { v.pct = e.loaded / e.total; disegna(); } };
      x.onload = function () {
        var d = null;
        try { d = JSON.parse(x.responseText); } catch (e) { /* risposta non JSON: 413 o pagina d'errore */ }
        var url = d && d.properties && d.properties[nome];
        if (x.status !== 200 || !url) { ko(new Error('upload ' + x.status)); return; }
        /* la riga serviva solo a portare il file: via dal carrello */
        fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: d.key, quantity: 0 })
        }).catch(function () {});
        ok(url);
      };
      x.onerror = function () { ko(new Error('rete')); };
      x.send(fd);
    });
  }

  function lavora(v, n) {
    v.stato = 'comprimo'; v.pct = null; disegna();
    return comprimi(v).then(function (file) {
      v.out = file;
      if (file.size > MAX) {
        v.stato = 'errore';
        v.err = /^video\//.test(file.type) ? T.err_video : T.err_peso;
        disegna();
        return;
      }
      v.stato = 'carico'; v.pct = 0; disegna();
      return carica(v, file, n).then(function (url) {
        v.url = url; v.stato = 'fatto'; disegna();
      }, function () {
        v.stato = 'errore'; v.err = T.err_upload; disegna();
      });
    });
  }

  /* ── Cerca per obiettivo: WhatsApp ─────────────────────────────────────── */

  /* L'indirizzo dei pulsanti si riscrive a ogni lettera (e al clic), cosi' il
     testo viaggia anche aprendo il link in altro modo. Al clic il messaggio si
     copia: la nuova app WhatsApp per computer a volte ignora il testo del link
     (il titolare se l'e' visto arrivare vuoto, 21/10/2026), e allora basta
     incollarlo. Su computer c'e' anche WhatsApp Web, che il testo lo tiene. */
  var wa = box.querySelector('[data-rq-wa]');
  var waApp = box.querySelector('[data-rq-app]');
  var waLink = box.querySelector('[data-rq-link]');
  var riserva = box.querySelector('[data-rq-riserva]');
  var anteprima = box.querySelector('[data-rq-anteprima]');
  var copiato = box.querySelector('[data-rq-copiato]');
  /* telefono e tablet: niente hover, schermo a tocco */
  var tocco = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  function messaggio() {
    var t = testo.value.trim();
    return (T.wa_intro || '') + (t ? '\n\n' + t : '') + '\n\n' + (T.wa_pagina || '') + ' ' + location.href.split('#')[0];
  }
  function apriWa() {
    if (!wa) return;
    var m = encodeURIComponent(messaggio()), n = wa.getAttribute('data-rq-wa');
    var app = 'whatsapp://send?phone=' + n + '&text=' + m;
    if (tocco) { wa.href = app; wa.removeAttribute('target'); }
    else { wa.href = 'https://web.whatsapp.com/send?phone=' + n + '&text=' + m; wa.setAttribute('target', '_blank'); }
    if (waApp) waApp.href = app;
    if (waLink) waLink.href = 'https://wa.me/' + n + '?text=' + m;
    if (anteprima) anteprima.textContent = messaggio();
  }
  function copia() {
    var m = messaggio();
    var fatto = function () { if (copiato) copiato.hidden = false; };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(m).then(fatto, function () {}); return; }
    } catch (err) { /* niente appunti: resta il link */ }
    try {
      var ta = document.createElement('textarea'); ta.value = m; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
      if (document.execCommand('copy')) fatto();
      document.body.removeChild(ta);
    } catch (err) { /* niente */ }
  }
  /* se l'app non si apre (telefono senza WhatsApp) la pagina resta visibile:
     dopo 2 secondi compare il link di riserva */
  function riservaSeServe() {
    if (!riserva) return;
    var t0 = Date.now();
    setTimeout(function () { if (!document.hidden && Date.now() - t0 < 4000) riserva.hidden = false; }, 2000);
  }
  if (wa) {
    wa.addEventListener('click', function () { apriWa(); copia(); if (tocco) riservaSeServe(); });
    if (waApp) waApp.addEventListener('click', function () { apriWa(); copia(); riservaSeServe(); });
    if (waLink) waLink.addEventListener('click', function () { apriWa(); copia(); });
    var bCopia = box.querySelector('[data-rq-copia]');
    if (bCopia) bCopia.addEventListener('click', function (e) { e.preventDefault(); apriWa(); copia(); });
    testo.addEventListener('input', apriWa);
    apriWa();
  }

  /* ── Invio ────────────────────────────────────────────────────────────── */

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (occupato) return;
    /* "Invia" nel modo obiettivo: si va su WhatsApp, non in mail. Il testo si
       copia anche negli appunti, cosi' lo si incolla se l'app non lo riporta. */
    if (modo === 'obiettivo') {
      if (testo.value.trim().length < 3) { msg.textContent = T.err_testo; msg.classList.add('is-err'); testo.focus(); return; }
      if (wa) { apriWa(); copia(); window.open(wa.href, '_blank', 'noopener'); }
      return;
    }
    msg.classList.remove('is-err');
    if (testo.value.trim().length < 3 && !voci.length) {
      msg.textContent = T.err_testo; msg.classList.add('is-err'); testo.focus(); return;
    }
    if (!form.checkValidity()) {
      msg.textContent = T.err_campi; msg.classList.add('is-err');
      var bad = form.querySelector(':invalid');
      if (bad) bad.focus();
      return;
    }
    occupato = true;
    invia.disabled = true;
    msg.textContent = T.inviando;
    var catena = Promise.resolve();
    voci.forEach(function (v, i) {
      if (v.stato === 'fatto') return;
      catena = catena.then(function () { return vid ? lavora(v, i + 1) : null; });
    });
    catena.then(function () {
      if (voci.some(function (v) { return v.stato === 'errore'; })) {
        /* un file non e' partito: si ferma qui, il cliente lo toglie o riprova */
        occupato = false;
        invia.disabled = false;
        msg.textContent = T.err_upload;
        msg.classList.add('is-err');
        disegna();
        return;
      }
      var righe = voci.map(function (v) {
        return v.url ? v.nome + ' — ' + peso((v.out || v.file).size) + ' — ' + v.url
          : v.nome + ' — NON CARICATO (' + (v.err || 'errore') + ')';
      });
      box.querySelector('[data-rq-allegati]').value = righe.length ? righe.join('\n') : 'Nessuno';
      box.querySelector('[data-rq-pagina]').value = location.href.split('#')[0];
      box.querySelector('[data-rq-body]').value =
        box.querySelector('[data-rq-tipo]').value + '\n\n' + testo.value.trim() +
        (righe.length ? '\n\nAllegati:\n' + righe.join('\n') : '');
      occupato = false;
      /* ?rq_prova=1: fa tutto (compressione e caricamento compresi) tranne
         spedire, e lascia sul box quello che sarebbe partito. Serve a
         collaudare senza mandare mail finte al negozio. */
      if (/[?&]rq_prova=1/.test(location.search)) {
        var fd = {};
        new FormData(form).forEach(function (val, k) { fd[k] = typeof val === 'string' ? val : '[file]'; });
        box.setAttribute('data-rq-prova', JSON.stringify(fd));
        invia.disabled = false;
        msg.textContent = 'PROVA: modulo pronto, non inviato.';
        return;
      }
      try { sessionStorage.setItem(CHIAVE, modo); } catch (err) { /* navigazione privata */ }
      HTMLFormElement.prototype.submit.call(form);
    });
  });

  /* Dopo l'invio Shopify ricarica la pagina con ?contact_posted=true: se
     l'invio era il nostro, si riapre la finestra sul ringraziamento. */
  var inviata = null;
  try { inviata = sessionStorage.getItem(CHIAVE); } catch (err) { /* niente */ }
  if (inviata) {
    try { sessionStorage.removeItem(CHIAVE); } catch (err) { /* niente */ }
    if (box.querySelector('[data-rq-postato]')) {
      apri(inviata);
      form.hidden = true;
      grazie.hidden = false;
    } else if (box.querySelector('[data-rq-errori-server]')) {
      apri(inviata);
    }
  }
})();
